<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs v-model="type" @tab-click="handleClick">
			<el-tab-pane :label="$t('systemSet.title')" name="1">
				<el-form ref="form" :model="form_1" v-if="type==1" :label-position="this.layout.is_phone?'top':''" label-width="300px">
				
					<el-form-item :label="item.name" 
					v-for="(item,index) in list">

						<el-input v-if="item.other_type == 0" :placeholder="item.name" type="text" :class="layout.is_phone?'':'w-50'"  v-model="item.value_set">
						   	<template v-if="item.remark" slot="append">{{item.remark}}</template>
						</el-input>
						
						<el-switch 
							v-else-if="item.other_type === 1" 
							v-model="item.value_set"
							active-value="1"
    						inactive-value="0"
						>
						</el-switch>

					
						<quill-editor  v-else-if="item.other_type === 3"  ref="text" v-model="item.value_set" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
						
						<el-date-picker
							v-else-if="item.other_type === 4"
							v-model="item.value_set"
							value-format="yyyy-MM-dd"
							type="date"
							:placeholder="$t('systemSet.selDate')">
						</el-date-picker>

					</el-form-item>
					<el-form-item >
						<el-button v-auth="'addSystem'" @click="addOrEdit" type="primary">{{$t('layout.save')}}</el-button>
					</el-form-item>
					
				</el-form>
			</el-tab-pane>
			<!-- <el-tab-pane label="銀行信息" name="2">
				<el-form ref="form" :model="form_2" v-if="type==2" :label-position="this.layout.is_phone?'top':''" label-width="300px">
				
					<el-form-item :label="item.name" 
					v-for="(item,index) in list">


					<el-input v-if="item.other_type == 0" :placeholder="item.name" type="text" :class="layout.is_phone?'':'w-50'"  v-model="item.value_set">
						   	<template v-if="item.remark" slot="append">{{item.remark}}</template>
						</el-input>
						
						<el-switch 
							v-else-if="item.other_type === 1" 
							v-model="item.value_set"
							active-value="1"
    						inactive-value="0"
						>
						</el-switch>

					
						<quill-editor  v-else-if="item.other_type === 3"  ref="text" v-model="item.value_set" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
						
						<el-date-picker
							v-else-if="item.other_type === 4"
							v-model="item.value_set"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="選擇日期">
						</el-date-picker>

						<el-upload
							v-else-if="item.other_type === 2" 
							name="file"
							class="avatar-uploader"
							action="/admin/image/uploadNew"
							:headers="{token: $store.state.user.token}"
							:data="{type: '7', cms_type: '1'}"
							:show-file-list="false"
							:on-success="(res, file) => handleAvatarSuccess(res, file, item)"
							:before-upload="beforeAvatarUpload"
						>
							<img v-if="item.value_set" :src="item.value_set" class="avatar" />
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						

						<el-input v-if="item.other_type == 5" :placeholder="item.name" type="textarea"
						:rows="4" :class="layout.is_phone?'':'w-50'"  v-model="item.value_set">
						   	<template v-if="item.remark" slot="append">{{item.remark}}</template>
						</el-input>
					

					</el-form-item>
					<el-form-item >
						<el-button v-auth="'addSystem'" @click="addOrEdit" type="primary">保存</el-button>
					</el-form-item>
					
				</el-form>
			</el-tab-pane>
			<el-tab-pane label="app基礎設置" name="3">
				<el-form ref="form" :model="form_3" v-if="type==3" :label-position="this.layout.is_phone?'top':''" label-width="300px">
				
					<el-form-item :label="item.name" 
					v-for="(item,index) in list">
					<el-input v-if="item.other_type == 0" :placeholder="item.name" type="text" :class="layout.is_phone?'':'w-50'"  v-model="item.value_set">
						   	<template v-if="item.remark" slot="append">{{item.remark}}</template>
						</el-input>
						
						<el-switch 
							v-else-if="item.other_type === 1" 
							v-model="item.value_set"
							active-value="1"
    						inactive-value="0"
						>
						</el-switch>

					
						<quill-editor  v-else-if="item.other_type === 3"  ref="text" v-model="item.value_set" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
						
						<el-date-picker
							v-else-if="item.other_type === 4"
							v-model="item.value_set"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="選擇日期">
						</el-date-picker>
						
					</el-form-item>
					<el-form-item >
						<el-button v-auth="'addSystem'" @click="addOrEdit" type="primary">保存</el-button>
					</el-form-item>
					
				</el-form>
			</el-tab-pane>
			<el-tab-pane label="題目設置" name="4">
				<el-form ref="form" :model="form_4" v-if="type==4" :label-position="this.layout.is_phone?'top':''" label-width="300px">
				
					<el-form-item :label="item.name" 
					v-for="(item,index) in list">
					<el-input v-if="item.other_type == 0" :placeholder="item.name" type="text" :class="layout.is_phone?'':'w-50'"  v-model="item.value_set">
						   	<template v-if="item.remark" slot="append">{{item.remark}}</template>
						</el-input>
						
						<el-switch 
							v-else-if="item.other_type === 1" 
							v-model="item.value_set"
							active-value="1"
    						inactive-value="0"
						>
						</el-switch>

					
						<quill-editor  v-else-if="item.other_type === 3"  ref="text" v-model="item.value_set" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
						
						<el-date-picker
							v-else-if="item.other_type === 4"
							v-model="item.value_set"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="選擇日期">
						</el-date-picker>
						
					</el-form-item>
					<el-form-item >
						<el-button v-auth="'addSystem'" @click="addOrEdit" type="primary">保存</el-button>
					</el-form-item>
					
				</el-form>
			</el-tab-pane>
			<el-tab-pane label="支付設置" name="5">
				<el-form ref="form" :model="form_5" v-if="type==5" :label-position="this.layout.is_phone?'top':''" label-width="300px">
				
					<el-form-item :label="item.name" 
					v-for="(item,index) in list">
					<el-input v-if="item.other_type == 0" :placeholder="item.name" type="text" :class="layout.is_phone?'':'w-50'"  v-model="item.value_set">
						   	<template v-if="item.remark" slot="append">{{item.remark}}</template>
						</el-input>
						
						<el-switch 
							v-else-if="item.other_type === 1" 
							v-model="item.value_set"
							active-value="1"
    						inactive-value="0"
						>
						</el-switch>

					
						<quill-editor  v-else-if="item.other_type === 3"  ref="text" v-model="item.value_set" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
						
						<el-date-picker
							v-else-if="item.other_type === 4"
							v-model="item.value_set"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="選擇日期">
						</el-date-picker>
						
					</el-form-item>
					<el-form-item >
						<el-button v-auth="'addSystem'" @click="addOrEdit" type="primary">保存</el-button>
					</el-form-item>
					
				</el-form>
			</el-tab-pane> -->
			
		</el-tabs>
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import tinymce from '@/components/common/tinymce.vue';
	import { mapState } from 'vuex';
	export default {
		components:{
			tinymce
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				editorOptions: {
					modules: {
						toolbar: [
							[{ header: [1, 2, false] }], // 標題选项
							['bold', 'italic', 'underline','image','indent','clean'], // 粗体、斜体、下划线
						]
					},
					placeholder: ''  // 设置占位符
				},

				type: '1',
				xyIndex:0,
				form_1: {},
				preUrl: "user/systemList", //列表地址
				addUrl: "user/addSystem", //修改地址
				tableData: [],
				checkboxGroup1: [],
				list:{},
				content:""
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods:{
			// 鼠標點擊事件
			onClick(e, editor) {
			
			},
			getListResult(e) {
				if(this.type==7){
					this.list = e.list.map(item=>{
						
						item.value_set = item.value_set==1?true:false
						return item
					})
					
					this.list = e.list
				}else{
					
					this.list = e.list
					
				}
				
				
				console.log(this.list)
			},
			handleClick(tab, event) {
				this.list = [];
				this.search = ''
				this.getList()
			},
			
			addOrEdit() {
				this.layout.loading = true;
				this.axios.post(this.addOrEditUrl(), {data:this.list}, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message:  this.$t('system.openSucc'),
							type: 'success'
						});
						
					}
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			},
				
		
			handleAvatarSuccess(res, file, item) {
				// 临时顯示上傳的文件预览 URL
				item.value_set = URL.createObjectURL(file.raw);

				// 解密并解析服务器返回的數据
				let en_data = commondecrypt(res.encryption);
				res.encryption = JSON.parse(en_data);

				// 如果响应狀態碼为 1，则设置图片 URL 到 item.value_set
				if (res.encryption.code === 1) {
					item.value_url = res.encryption.data.list.url;
					
				}
			},

			
			  beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				return isLt2M;
			  },
			

			// 選擇图片
			chooseImage(index) {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.list[index], 'value_set', res[0].url);
					this.$set(this.list[index], 'url_id', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		},
		
	}
</script>

<style>
	.tox-silver-sink{
		z-index: 2006!important;
	}
</style>
